<template>
  <div class="detail">
    <div class="cHeader">
      <div class="navit">
        <div class="backbtn" @click="tohome">
          <!-- <el-button type="primary" @click="tohome">首页</el-button> -->
          <div>
            <img :src="homeimg" alt>
          </div>
          <div>
            <p>
              <span>科技数字化网站</span>
            </p>
          </div>
        </div>
        <div
          v-for="(item, index) in navlist"
          :key="index"
          :class="nowitem == item.id ? 'itema item' : 'itemb item'"
          @click="changerouter(item.id)"
        >
          <p>
            <i :class="item.icon"></i>
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="rowheader">
      <div class="headertext">
        <div>
          <span @click="tohome">首页</span>
          <span>/</span>
          <span>{{ nowtitletxt }}</span>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <Footers/>
  </div>
</template>

<script>
// @ is an alias to /src

import Footers from "@/components/footer/index.vue";

export default {
  name: "detail",
  components: {
    Footers,
  },
  data() {
    return {
      nowitem: "1",
      ggmc:'',
      ztmc:'',
      spzbmc:'',
      wzmc:'',
      zlmc:'',

      navlist: [
        
      ],
      nowtitletxt: "",
      homeimg: require("@/assets/images/Group 104.png")
    };
  },
  computed: {},
  created() { },
  mounted() {
    this.getroute();
    this.getdhmc();
  },
  methods: {
    tohome() {
      this.$router.push('/home');
      this.$store.commit("SET_scrollId", "");
    },
    changerouter(id) {
      this.nowitem = id;
      switch (id) {
        case "1":
          this.$router.push({ path: "/noticedetail" });
          break;
        case "2":
          this.$router.push({ path: "/specialdetail" });
          break;
        case "3":
          this.$router.push({ path: "/videodetail" });
          break;
        case "4":
          this.$router.push({ path: "/articledetail" });
          break;
        case "5":
          this.$router.push({ path: "/Informationdetail" });
          break;
      }
      this.getnowtitletxt();
    },
    getnowtitletxt() {

      switch (this.nowitem) {
        case "1":
          // this.nowtitletxt = "公告";
          this.nowtitletxt = this.ggmc;
          break;
        case "2":
          // this.nowtitletxt = "专题";
          this.nowtitletxt = this.ztmc;
          break;
        case "3":
          // this.nowtitletxt = "视频";
          this.nowtitletxt = this.spzbmc;
          break;
        case "4":
          // this.nowtitletxt = "文章";
          this.nowtitletxt = this.wzmc;
          break;
        case "5":
          // this.nowtitletxt = "资料";
          this.nowtitletxt = this.zlmc;
          break;
      }
    },
    getroute() {
      //   console.log(this.$route.path);
      switch (this.$route.path) {
        case "/noticedetail":
          this.nowitem = '1';

          break;
        case "/specialdetail":
          this.nowitem = '2';

          break;
        case "/videodetail":
          this.nowitem = '3';

          break;
        case "/articledetail":
          this.nowitem = '4';

          break;
        case "/Informationdetail":
          this.nowitem = '5';

          break;
      }

      this.getnowtitletxt();
    },
    getdhmc() {
      // let data = this.$qs.stringify({
      // });
      this.$axios({
        method: "post",
        url: "/admin/kjhqt/dh_module_list",
        // data: data
      })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res)
            this.list = res.data.data;
            this.ggmc = res.data.data[0].module_name;
            this.ztmc = res.data.data[1].module_name;
            this.spzbmc = res.data.data[2].module_name;
            this.wzmc = res.data.data[3].module_name;
            this.zlmc = res.data.data[4].module_name;
            this.navlist= [
        {
          // name: "公告展示",
          name: this.ggmc,
          url: "",
          icon: "el-icon-message-solid",
          id: "1",
          srollid: "noticecontainer",
        },
        {
          // name: "专题展示",
          name:this.ztmc,
          url: "",
          icon: "el-icon-s-ticket",
          id: "2",
          srollid: "specialcontainer",
        },
        {
          // name: "视频、直播展示",
          name:this.spzbmc,
          url: "",
          icon: "el-icon-video-camera-solid",
          id: "3",
          srollid: "videocontainer",
        },
        {
          // name: "文章展示",
          name:this.wzmc,
          url: "",
          icon: "el-icon-s-order",
          id: "4",
          srollid: "articlecontainer",
        },
        {
          // name: "资料展示",
          name:this.zlmc,
          url: "",
          icon: "el-icon-s-management",
          id: "5",
          srollid: "Informationcontainer",
        },
      ];
      }
          
        })
        .catch(err => {
           //this.$message.error(err);
        });
    },
  },
  watch: {},
};
</script>
<style lang="less">
.detail {
  background-color: #ffffff;
  .cHeader {
    width: 100%;
    height: 70px;

    .navit {
      width: 100%;
      height: 100%;
      background: #4260ff;
      display: flex;
      justify-content: center;
      position: relative;
      .backbtn {
        width: 300px;
        height: 100%;
        position: absolute;
        left: 1vw;
        top: 0px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        > div:nth-of-type(1) {
          width: 50px;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          > img {
            width: 40px;
            height: 40px;
            margin: 0 auto;
          }
        }
        > div:nth-of-type(2) {
          width: 230px;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          > p {
            font-size: 28px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            font-weight: 500;
          }
        }
      }
      .item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-width: 12%;
        height: 100%;
        cursor: pointer;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 500;
        font-size: 2.2vh;
      }
      .itema {
        color: #1639f3;
        background: linear-gradient(
          180deg,
          #f0f3ff 0%,
          #dfe6ff 48.44%,
          #f0f3ff 99.48%
        );
        box-shadow: 0px 0px 4px rgba(0, 21, 135, 0.18);
      }
      .itemb {
        color: #ffffff;
      }
    }
  }
  .rowheader {
    width: 75%;
    // min-height: 600px;
    margin: 0 auto;
    height: 60px;
    margin-top: 4vh;
    .headertext {
      height: 100%;
      width: 100%;
      // display: flex;
      // justify-content: center;
      // flex-direction: column;

      display: flex;
      justify-content: left;
      > div:nth-of-type(1) {
        width: 150px;
        text-align: left;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 2.4vh;
        letter-spacing: 0.08em;
        color: #00041a;
        > span {
          cursor: pointer;
        }
        > span:nth-of-type(1):hover {
          color: #4260ff;
        }
      }
      // > div:nth-of-type(2) {
      //   width: 150px;
      // }
    }
  }
  > div {
    width: 75%;
    // min-height: 600px;
    margin: 0 auto;
  }
}
</style>


